var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "step__range" }, [
    _vm.units.length > 1
      ? _c(
          "div",
          { staticClass: "calculator__units" },
          _vm._l(_vm.units, function(unit, i) {
            return _c(
              "div",
              {
                key: unit.name,
                staticClass: "unit",
                class: { unit_active: i === _vm.activeUnitIndex },
                on: {
                  click: function($event) {
                    _vm.activeUnitIndex = i
                  }
                }
              },
              [_vm._v("\n      " + _vm._s(unit.name) + "\n    ")]
            )
          }),
          0
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "range__value" }, [
      _c("div", { staticClass: "value" }, [
        _vm._v(
          _vm._s(
            Math.round(_vm.value * _vm.activeUnit.precision) /
              _vm.activeUnit.precision
          )
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "unit" }, [
        _vm._v("\n      " + _vm._s(_vm.activeUnit.name) + "\n    ")
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "slider__wrapper",
        on: {
          mousedown: _vm.startMoving,
          mousemove: _vm.moveSlider,
          mouseup: _vm.endMoving,
          touchstart: _vm.startMoving,
          touchmove: _vm.moveSlider,
          mouseleave: _vm.endMoving
        }
      },
      [
        _c(
          "div",
          {
            staticClass: "range__slider",
            style: { left: _vm.rangeLeft + "px" }
          },
          [
            _c(
              "div",
              { staticClass: "range__slides" },
              _vm._l(_vm.slidesCount + 1, function(n) {
                return _c(
                  "div",
                  {
                    staticClass: "range__slide",
                    class: {
                      slide_long:
                        Math.round(n - _vm.activeUnit.step + _vm.minCorrected) %
                          10 ===
                        0,
                      slide_active:
                        Math.round(_vm.value * _vm.activeUnit.precision) /
                          _vm.activeUnit.precision ===
                        Math.round(
                          ((n - _vm.activeUnit.step) * _vm.sliderStep +
                            _vm.minCorrected) *
                            _vm.activeUnit.precision
                        ) /
                          _vm.activeUnit.precision
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              Math.round(
                                n - _vm.activeUnit.step + _vm.minCorrected
                              ) %
                                10 ===
                              0,
                            expression:
                              "Math.round((n - activeUnit.step) + minCorrected) % 10 === 0"
                          }
                        ],
                        staticClass: "slide__value"
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              Math.round(
                                ((n - _vm.activeUnit.step) * _vm.sliderStep +
                                  _vm.minCorrected) *
                                  _vm.activeUnit.precision
                              ) / _vm.activeUnit.precision
                            ) +
                            "\n          "
                        )
                      ]
                    )
                  ]
                )
              }),
              0
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }